// extracted by mini-css-extract-plugin
export default {"contact-text":"forgotten_contact-text__xEiu8"};